export default {
  alpine: {
    companyName: 'Alpine',
    fileExtensions: ['pic'],
  },
  eagle: {
    companyName: 'Eagle',
    fileExtensions: ['kxr', 'kxf'],
  },
  mitek: {
    companyName: 'Mitek',
    fileExtensions: ['tre'],
  },
  simpson: {
    companyName: 'Simpson',
    fileExtensions: ['tdlTruss'],
  },
  clearspan: {
    companyName: 'Clearspan',
    fileExtensions: ['xml', 'clearspan'],
  },
} as const;
